import axiosInst from "api/config/axiosConfig";
import { DemoUserAddTypes, setUserIsDisabledTypes, UserRequestType } from "./demo-users.config";
import { getExpirationDate } from "utils/general";

export const userStatus = {
  disable: "disable",
  extend: "extend",
};

export const addDemoUsers = async (user: DemoUserAddTypes) => {
  const response = await axiosInst.post("/beta/usersAdd", user);
  return response.data;
};

export const getDemoUsers = async (user: UserRequestType) => {
  const response = await axiosInst.post("/beta/usersList", user);
  const users = response.data.Users;

  const mappedUsersWithExpire = users.map(async (element: any) => {
    const userData = element;
    const expirationDate = await getExpirationDate(userData.Username);
    userData.expirationDate = expirationDate;
    return userData;
  });

  return Promise.all(mappedUsersWithExpire);
};

export const getDemoDevices = async () => {
  const response = await axiosInst.get("/beta/appSystemInfo?demodevices=all");
  return response.data;
};

export const getUserDevices = async (userId: string) => {
  const response = await axiosInst.get(`/beta/appSystemInfo?demouser=${userId}`);
  return response.data;
};

export const updateDemoDevices = async (body: any) => {
  const response = await axiosInst.put("/beta/appSystemInfo", body);
  return response.data;
};

export const updateAssignedDevices = async (body: any) => {
  const response = await axiosInst.put("/beta/appSystemInfo", body);
  return response.data;
};

export const setUserIsDisabled = async (body: setUserIsDisabledTypes) => {
  const response = await axiosInst.post("/beta/userEnableDisable", body);
  return response.data;
};

export const deleteDemoUser = async (body: setUserIsDisabledTypes) => {
  const response = await axiosInst.post("/beta/userDelete", body);
  return response.data;
};
